import React, { useEffect, useState } from 'react';
import { CustomerWhatsappModelItem } from '../models/superbit-api-models';
import moment from 'moment';

type Props = {
    whatsAppMessageDetails: CustomerWhatsappModelItem;
    config: any;
};

const ClientWhatsAppMessage =(props: Props)=> {
    const [whatsAppMessage, setWhatsAppMessage] = useState<CustomerWhatsappModelItem>(props.whatsAppMessageDetails);
    const [apiUrl, setApiUrl] = useState<string>('');

    useEffect(()=>{
        const aUrl = localStorage.getItem('apiUrl');
        if (apiUrl == '' && aUrl) {
            setApiUrl(aUrl);
        }
    }, [props])

    
    const downloadDocument = (docUrl: string | undefined) => {
        if(apiUrl !== '' && docUrl) {
            const fileUrl = `${apiUrl}${docUrl}`;
            console.log('downloadDocument', fileUrl );
            const anchor = document.createElement('a');
            anchor.href = fileUrl;
            anchor.target='_blank';
            anchor.download = 'filename.pdf'; // Set the filename you want
            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);
        }
    }

    const emptyFunc = () => {}
    
    return (
        <div className="data-card client-details-row client-item flex-space-between">
            <div className="data-card-body flex-space-between">
                <div className="cell">
                    <div className="description cell-value">
                        {moment(whatsAppMessage.createdDate).format('DD-MM-YYYY')}
                    </div>
                </div>
                <div className="cell">
                    <div className="description cell-value">
                        {whatsAppMessage.text }
                    </div>
                </div>
                <div className="cell">
                    <div className="description cell-value">
                        {whatsAppMessage.reciveOrSent }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ClientWhatsAppMessage;